/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from "react";
import MaterialRequestDetailsListSection from "./MaterialRequestDetailsListSection";
import MaterialRequestDetailsSectionInfo from "./MaterialRequestDetailsSectionInfo";
import MaterialRequestDetailsApp from "../../Functionality/MaterialRequestDetailsApp";
import {permissionObj} from "../../../../../Helpers/permission";
import routes from "../../../../../Routes/routes";
import DivContainerBody from "../../../../../components/DivContainerBody";
import HeadTittle from "../../../../../components/HeadTittle";
import MaterialDispatchBadge from "../MaterialDispatch/MaterialDispatchBadge";
import MaterialApprovalBadge from "../Approval/MaterialApprovalBadge";
import {getStatusConfig} from "../../../Visitor/Request/Model/Model";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";

const MaterialRequestDetails = () => {
    const {
        t,
        navigate,
        DEV,
        isGuard,
        permission,
        contentCardRef,
        contentTableRef,
        containerCardRef,
        containerTableRef,
        item,
        goBack,
        evidence,
        showBadge
    } = MaterialRequestDetailsApp();

    if (!DEV && !isGuard &&
        !permission?.includes(permissionObj.WEB_MATERIAL_REQUEST_READ)
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'details'} onBack={goBack}>
            </HeadTittle>
            <DivContainerBody>
                <div className={"mb-4"}>
                    {showBadge ?
                        <MaterialDispatchBadge
                            t={t}
                            showBadge={showBadge}
                            dispatchStatusId={item?.dispatchStatusId}
                            dispatchReason={item?.dispatchReason}
                            dispatchDate={item?.dispatchDate}
                            dispatchUser={item?.dispatchUser}
                            />
                        : item?.approvalStatusId === STATUS_MODEL.DENIED &&
                            <MaterialApprovalBadge
                                t={t}
                                currentStatusConfig={getStatusConfig(item?.approvalStatusId)}
                                approvalReason={item?.approvalReason}
                                approvalUser={item?.approvalUser}
                                approvalDate={item?.approvalDate}
                            />
                    }
                </div>
                <div className='row px-0'>
                    <div className='col-sm-12 col-md-4 col-lg-4 mb-lg-0 mb-md-3 mb-sm-3 pl-0 pr-sm-0 pr-md-3'
                         ref={containerCardRef}>
                        <MaterialRequestDetailsSectionInfo
                            item={item}
                            evidence={evidence}
                            contentCardRef={contentCardRef}
                        />
                    </div>
                    <div className='col-sm-12 col-md-8 col-lg-8 px-0' ref={containerTableRef}>
                        <MaterialRequestDetailsListSection
                            contentTableRef={contentTableRef}
                            data={item}
                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default MaterialRequestDetails;
